<template>
  <v-container
    class="fill-height login-page"
    fluid
  >
    <v-row
      align="center"
      justify="center"
      class="mx-auto"
      style="min-height: calc(100vh - 100px);"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="mx-auto elevation-6" :loading="loading" style="max-width: 368px;">
          <div class="logo text-center pt-10 pb-6">
            <img src="../assets/images/login.svg" alt="">
          </div>
          <p class="form-title mb-4 text-center">Введіть логін і пароль</p>

          <v-alert
            v-show="error"
            type="error"
            class="mb-3 mx-6 flat"
            dense
          >{{ error }}</v-alert>

          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="onSubmit"
          >
            <v-card-text class="px-6">
              <v-text-field
                placeholder="Логін"
                v-model.trim="form.username"
                :rules="rules.username"
                type="text"
                class="custom-input mb-1"
                outlined
                dense
                prepend-inner-icon="perm_identity"
              />

              <v-text-field
                placeholder="Пароль"
                v-model.trim="form.password"
                :rules="rules.password"
                class="custom-input mb-1"
                outlined
                dense
                prepend-inner-icon="mdi-lock-outline"
                :append-icon="password_show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="password_show ? 'text' : 'password'"
                @click:append="password_show = !password_show"
              />

<!--              <v-checkbox-->
<!--                v-model="form.remember"-->
<!--                :label="`Запам'ятати`"-->
<!--                class="ml-1 mt-0 mb-2"-->
<!--                color="#333333"-->
<!--              ></v-checkbox>-->

              <v-btn
                type="submit"
                @keyup.enter="onSubmit"
                rounded
                dark
                depressed
                large
                :loading="loading"
                class="down w-100 mb-4 btn-custom-default-color"
              >Увійти</v-btn>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'login-page',
  metaInfo() {
    return {
      title: 'Авторизація | Transport Map'
    }
  },
  data() {
    return {
      valid: true,
      loading: false,
      form: {
        username: '',
        password: '',
        remember: true  // do not change
      },
      password_show: false,
      rules: {
        username: [v => !!v || `Поле Логін обов'язково`],
        password: [v => !!v || `Поле Пароль обов'язково`]
      },
      error: ''
    }
  },
  methods: {
    handleErrorText(error) {
      if (error.response.data.non_field_errors[0] == 'Unable to log in with provided credentials.') {
        this.error = 'Неправильний логін або пароль'
      } else {
        this.error = JSON.stringify(error.response.data)
      }
    },
    onSubmit() {
      if(this.$refs.form.validate()) {
        this.$store.dispatch('AUTH_REQUEST', this.form)
        .then(() => this.$router.push('/'))
        .catch(error => this.handleErrorText(error))
      }
    }
  }
}
</script>